<button
  #originRef
  (click)="showPopover()"
  [class.bg-hover]="dropdownOpen"
  class="button relative"
  mat-icon-button
  type="button">
  <mat-icon class="!text-white" svgIcon="mat:notifications_active"></mat-icon>
  <span *ngIf="hayNotificacionesSinLeer" class="indicador-notificacion"></span>
</button>
